/* baby enRoute GA4 select_item v2 - 2026-08-24 */
(function () {
  'use strict';

  if (window.__berGa4SelectItemInstalled) return;
  window.__berGa4SelectItemInstalled = true;

  var MEASUREMENT_ID = 'G-3L4C8J9G0K';
  var PENDING_KEY = 'berGa4PendingSelectItem';
  var lastClickKey = '';
  var lastClickAt = 0;
  var store = null;
  try {
    store = window.sessionStorage;
  } catch (_error) {
    store = null;
  }

  function clearPending() {
    try {
      store.removeItem(PENDING_KEY);
    } catch (_error) {
      // Storage is blocked or unavailable.
    }
  }

  function flushPendingSelection(attempt) {
    if (!store) return;
    var pending;
    try {
      pending = JSON.parse(store.getItem(PENDING_KEY) || 'null');
    } catch (_error) {
      clearPending();
      return;
    }
    if (!pending) return;

    var age = Date.now() - Number(pending.created_at || 0);
    if (age < 0 || age > 30000) {
      clearPending();
      return;
    }
    if (pending.pathname !== window.location.pathname) return;

    if (typeof window.gtag !== 'function') {
      if (attempt < 40) {
        window.setTimeout(function () {
          flushPendingSelection(attempt + 1);
        }, 50);
      }
      return;
    }

    clearPending();
    window.gtag('event', 'select_item', pending.parameters);
  }

  flushPendingSelection(0);

  function text(node) {
    return node && node.textContent ? node.textContent.trim().replace(/\s+/g, ' ') : '';
  }

  function numberFromText(value) {
    var match = String(value || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : undefined;
  }

  function productJson(card) {
    var scripts = card.querySelectorAll('script[type="application/json"]');
    for (var index = 0; index < scripts.length; index += 1) {
      try {
        var value = JSON.parse(scripts[index].textContent || '{}');
        if (value && Array.isArray(value.variants)) return value;
      } catch (_error) {
        // Ignore unrelated JSON blocks in product cards.
      }
    }
    return {};
  }

  function activeVariantNode(card) {
    var selected = card.querySelector(
      '[data-variantid][aria-selected="true"], ' +
        '[data-variantid][aria-checked="true"], ' +
        '[data-variantid].selected, ' +
        '[data-variantid].active, ' +
        '[data-variantid].swatch-selected'
    );
    if (selected) return selected;

    var checked = card.querySelector('input:checked');
    if (checked && checked.closest) {
      selected = checked.closest('[data-variantid]');
      if (selected) return selected;
    }
    return card.querySelector('[data-variantid]');
  }

  function listContext(card) {
    var collectionMatch = window.location.pathname.match(/^\/collections\/([^/]+)/);
    if (collectionMatch) {
      return {
        id: 'collection_' + collectionMatch[1],
        name: text(document.querySelector('main h1')) || collectionMatch[1]
      };
    }

    if (window.location.pathname === '/search') {
      return { id: 'search_results', name: 'Search results' };
    }

    var section = card.closest('section, [id^="shopify-section-"]');
    var heading = section && section.querySelector('h2, h3');
    return {
      id: section && section.id ? section.id : 'product_list',
      name: text(heading) || 'Product list'
    };
  }

  function buildItem(link, card) {
    var data = productJson(card);
    var productIdNode = card.querySelector('[product-selector], [productid]');
    var productId = productIdNode
      ? productIdNode.getAttribute('product-selector') || productIdNode.getAttribute('productid')
      : '';
    if (!productId && card.id) {
      var productIdMatch = card.id.match(/-(\d{8,})-(?:description|variants-container)(?:-|$)/);
      if (productIdMatch) productId = productIdMatch[1];
    }

    var variantNode = activeVariantNode(card);
    var variantId = variantNode ? variantNode.getAttribute('data-variantid') : '';
    var variants = Array.isArray(data.variants) ? data.variants : [];
    if (!variantId && variants.length) variantId = String(variants[0].id || '');

    var variant = variants.find(function (candidate) {
      return String(candidate.id || '') === String(variantId || '');
    });
    if (!variant && variants.length) variant = variants[0];

    var headingLink = card.querySelector('.product-column_heading a[href*="/products/"]');
    var itemName = text(headingLink) || text(link) || text(card.querySelector('img[alt]'));
    var brand = text(card.querySelector('.product_vendor, .product_name-name'));
    var priceNode = card.querySelector(
      '.sale-price, .globo-cs-product_price, .main-price, .regular-price'
    );
    var position = Number(link.getAttribute('data-product-link-position') || 0);
    var context = listContext(card);

    var item = {
      item_id: productId && variantId ? 'shopify_ZZ_' + productId + '_' + variantId : productId,
      item_name: itemName,
      item_brand: brand,
      item_variant: variant ? variant.option1 || '' : '',
      item_list_id: context.id,
      item_list_name: context.name,
      index: position > 0 ? position - 1 : 0,
      quantity: 1
    };
    var price = numberFromText(text(priceNode));
    if (typeof price === 'number' && !Number.isNaN(price)) item.price = price;
    return { item: item, context: context };
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var link = target.closest('a[href*="/products/"]');
      if (!link) return;
      var card = link.closest('product-card');
      if (!card) return;
      var built = buildItem(link, card);
      if (!built.item.item_id || !built.item.item_name) return;

      var now = Date.now();
      var clickKey = built.item.item_id + '|' + link.pathname;
      if (clickKey === lastClickKey && now - lastClickAt < 750) return;
      lastClickKey = clickKey;
      lastClickAt = now;

      var shouldHandOffNavigation =
        event.button === 0 &&
        !event.metaKey &&
        !event.ctrlKey &&
        !event.shiftKey &&
        !event.altKey &&
        (!link.target || link.target === '_self') &&
        link.origin === window.location.origin;

      var eventParameters = {
        send_to: MEASUREMENT_ID,
        currency: 'CAD',
        item_list_id: built.context.id,
        item_list_name: built.context.name,
        items: [built.item]
      };

      if (shouldHandOffNavigation && store) {
        try {
          store.setItem(
            PENDING_KEY,
            JSON.stringify({
              created_at: Date.now(),
              pathname: link.pathname,
              parameters: eventParameters
            })
          );
          return;
        } catch (_error) {
          // Fall back to sending from the collection page if storage is blocked.
        }
      }

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'select_item', eventParameters);
      }
    },
    true
  );
})();
